import React,{useState} from 'react';
import { Table } from 'react-bootstrap';
import { amountFormat, dateFormatter } from '../../helpers/utilities';
const Invoiceinfo = (props) => {
  const {invData}=props

return (
  invData?.length ?
  <Table>
          <tbody>
            <tr>
            <th>Invoice Type</th>
            <th>Invoice Request Date</th>
            <th>Invoice Creation Date</th>
            <th>Invoice Paid Date</th>
            <th>Invoice Amount</th>
            </tr>
            {invData?.map((item)=>( <tr>
                <td>
                {item?.invoiceType}
                </td>
                <td>
                {dateFormatter({value:item?.invoiceReqDate})}
                </td>
                <td>
                {dateFormatter({value:item?.invoiceCrtnDate})}
                </td>
                <td>
                {dateFormatter({value:item?.invoicePaidDate})}
                </td>
                <td>
                {amountFormat.format(item?.invoiceAmount)}
                </td>
              </tr>))}
           
          </tbody>
  </Table>:
  <div style={{ textAlign: 'center' }}>No Invoice Information Found</div>
)
};

export default Invoiceinfo;
